
export const SampleBadgeDuplicate = () => {
    return (
        <span className="badge li-bg-duplicate ml-2 li-fg-white">DUP</span>
    );
};